/*
 * Copyright (c)  CYBERKOALA LLC 2025.
 * Proprietary License.
 * Redistribution and use in source and binary forms, with or without
 * modification, are restricted.
 */

import React, { useEffect, useState } from 'react';
import { DeepLinkContext } from './deep-link-context';
import { useNavigate } from 'react-router';
import { DEEPLINK_PREFIX } from '@/config.ts';

/**
 * @experimental, not used
 * Need to open deep link page?
 * @param children
 * @constructor
 */
export const DeepLinkProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [inviteCode, setInviteCode] = useState<string | null>(null);
  const navigate = useNavigate();


  useEffect(() => {
    const handler = (_: unknown, raw: string) => {
      try {
        const parsed = new URL(raw.includes('://') ? raw : `${DEEPLINK_PREFIX}${raw}`);

        const path = parsed.pathname !== '/' ? parsed.pathname : `/${parsed.host}`;

        navigate(path, { replace: true });
      } catch {
        navigate('/', { replace: true });
      }
    };

    window.ipcRenderer?.on('deep-link', handler);

    return () => {
      window.ipcRenderer?.removeListener('deep-link', handler);
    };
  }, [navigate]);

  return (
    <DeepLinkContext.Provider value={{ inviteCode }}>
      {children}
    </DeepLinkContext.Provider>
  );
};
